import { render, staticRenderFns } from "./131.vue?vue&type=template&id=67e36738&scoped=true&"
import script from "./131.vue?vue&type=script&lang=js&"
export * from "./131.vue?vue&type=script&lang=js&"
import style0 from "./131.vue?vue&type=style&index=0&id=67e36738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e36738",
  null
  
)

export default component.exports